import { render, staticRenderFns } from "./UpdatePost.vue?vue&type=template&id=5ec895ec&"
import script from "./UpdatePost.vue?vue&type=script&lang=js&"
export * from "./UpdatePost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports